import React, {useEffect} from 'react';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {LoginAsAdminContextProvider} from '../../components/LoginAsAdminContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import SectionPanel from '../../../../common/components/ui/SectionPanel';
import FieldAdmin from '../../components/FieldAdmin';
import FieldTargetUser from '../../components/FieldTargetUser';
import FieldPassword from '../../components/FieldPassword';
import ButtonLoginSubmit from "../../components/ButtonLoginSubmit";
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import styles from './LoginAsAdmin.module.scss';

const LoginAsAdmin = () => {
  const {setPageTitle} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'login-as-admin-page-header'}
        defaultMessage={'Login as administrator'}
        showLogo={true}
      />
    ));
  }, []);

  return (
    <LoginAsAdminContextProvider>
      <SectionPanel className={styles.loginContainer}>
        <FieldAdmin/>
        <FieldPassword/>
        <FieldTargetUser/>
        <div className={styles.buttonLoginContainer}>
          <ButtonLoginSubmit/>
        </div>
      </SectionPanel>
      <FooterLogo/>
    </LoginAsAdminContextProvider>
  );
};

export default LoginAsAdmin;
